import { EntityTypes } from '../new-lib/constants/common';

class ImageAltDescription {
  private readonly entity: any;
  private readonly entityType: string;
  private readonly locale: string;

  constructor(entity: any, entityType: string, locale?: string) {
    this.entity = entity;
    this.entityType = entityType;
    this.locale = locale ?? 'en';
  }

  private sanitize(text: string) {
    return text.replace(/\u200B/g, '');
  }

  getAltDescription(): string {
    if (
      this.entityType === EntityTypes.COMPOUND ||
      this.entityType === EntityTypes.SUPER_COMPOUND
    ) {
      return this.sanitize(
        `${this.entity.name} ${this.entity.area?.name ?? ''} ${
          this.entity.developer?.name ?? ''
        }`
      );
    }
    if (this.entityType === EntityTypes.PROPERTY) {
      const areaName =
        this.entity.compound?.area?.name || this.entity.area?.name;
      const description =
        this.locale === 'en'
          ? `${this.entity.property_type?.name ?? ''} for sale in ${
              this.entity.compound?.name ?? ''
            } in ${areaName ?? ''} of ${
              this.entity.min_unit_area ?? 0
            } m² with ${this.entity.number_of_bedrooms ?? 0} bedrooms`
          : `${this.entity.property_type?.name ?? ''} للبيع في ${
              this.entity.compound?.name ?? ''
            } في ${areaName ?? ''} بمساحة ${
              this.entity.min_unit_area ?? 0
            } م² تتكون من ${this.entity.number_of_bedrooms ?? 0} غرف`;

      return this.sanitize(description);
    }

    return this.sanitize('image');
  }
}

export default ImageAltDescription;
